// src/context/LayoutContext.js
import React, { createContext, useState, useContext } from 'react';

const LayoutContext = createContext(null);

export const LayoutProvider = ({ children }) => {
    const [headerTitle, setHeaderTitle] = useState('');

    return (
        <LayoutContext.Provider value={{ headerTitle, setHeaderTitle }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => useContext(LayoutContext);